import { render } from "./departmentList.vue?vue&type=template&id=3343ee4c&scoped=true"
import script from "./departmentList.vue?vue&type=script&lang=js"
export * from "./departmentList.vue?vue&type=script&lang=js"

import "./departmentList.vue?vue&type=style&index=0&id=3343ee4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3343ee4c"]])

export default __exports__